import React from 'react';

interface StarIconProps {
  className?: string;
  width?: number;
  height?: number;
  isFill?: boolean;
  fillColor?: string;
}

export const StarIcon = ({
  className,
  width,
  height,
  isFill = true,
  fillColor: _fillColor = '#231F2A',
}: StarIconProps) => {
  const fillColor = isFill ? _fillColor : '#FFF';
  const strokeColor = isFill ? _fillColor : '#D9D9DC';
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width || 33}
      height={height || 32}
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M16.3855 4.81411C16.4156 4.74232 16.4667 4.68091 16.5324 4.6377C16.5981 4.59448 16.6754 4.57141 16.7545 4.57141C16.8336 4.57141 16.9109 4.59448 16.9766 4.6377C17.0423 4.68091 17.0935 4.74232 17.1235 4.81411L20.2311 12.2629C20.2595 12.3311 20.3069 12.3901 20.3679 12.433C20.429 12.476 20.5011 12.5011 20.5761 12.5056L28.9533 13.0164C29.034 13.0213 29.1113 13.0502 29.1749 13.0992C29.2385 13.1483 29.2854 13.2151 29.3094 13.2909C29.3335 13.3666 29.3334 13.4478 29.3094 13.5236C29.2853 13.5993 29.2383 13.6661 29.1747 13.7151L22.7322 18.8036C22.6721 18.8511 22.6273 18.9146 22.6033 18.9865C22.5792 19.0584 22.5769 19.1356 22.5966 19.2087L24.6769 26.9355C24.6978 27.0115 24.6948 27.092 24.6682 27.1664C24.6417 27.2408 24.5929 27.3055 24.5283 27.3523C24.4637 27.399 24.3862 27.4255 24.3059 27.4283C24.2257 27.4311 24.1464 27.4101 24.0786 27.368L16.964 23.078C16.9012 23.0403 16.8291 23.0203 16.7555 23.0203C16.682 23.0203 16.6098 23.0403 16.5471 23.078L9.4325 27.368C9.36463 27.4101 9.28539 27.4311 9.20515 27.4283C9.12491 27.4255 9.0474 27.399 8.98276 27.3523C8.91811 27.3055 8.86934 27.2408 8.84282 27.1664C8.81631 27.092 8.81328 27.0115 8.83413 26.9355L10.9145 19.195C10.9313 19.1239 10.9276 19.0495 10.9036 18.9803C10.8796 18.9112 10.8364 18.8499 10.7788 18.8036L4.3324 13.7151C4.27003 13.6655 4.22435 13.5987 4.20133 13.5232C4.17831 13.4478 4.17902 13.3673 4.20336 13.2922C4.22771 13.2172 4.27456 13.1511 4.33779 13.1026C4.40102 13.0541 4.47769 13.0254 4.55779 13.0203L12.9349 12.5095C13.0099 12.505 13.0821 12.4799 13.1431 12.437C13.2042 12.394 13.2516 12.3351 13.28 12.2668L16.3855 4.81411Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
